import React, { Component } from 'react'
import { connect } from 'react-redux'
import ActivityIcon from '@mui/icons-material/Favorite';
import IconButton from '@mui/material/IconButton';
import { push } from '../components/routerPatch';

class ActivityNav extends Component {
    goToActivity = () => {    
        const { dispatch } = this.props
        dispatch(push('/activity'));
    }

    render() {
        const { isAuthed, userInfo, isFetching, hasJobsSuggestion, hasMatchesCan, hasApplicants, hasMatchesRec, view } = this.props
        let hideBadge = true

        if (userInfo){
            if (userInfo.lookingforwork){
                hideBadge = !(hasJobsSuggestion || hasMatchesCan)
            } else {
                hideBadge = !(hasApplicants || hasMatchesRec)
            }
        }

        return (
            <React.Fragment>
                {(isAuthed && userInfo && view === 'MOBILE')&&
                <IconButton
                    color="inherit"
                    aria-label="Activity"
                    disabled={isFetching}
                    onClick={this.goToActivity}
                    size="large">
                    <ActivityIcon style={{ fontSize: 32 }} color="primary" />
                    {(!hideBadge)&&<div className="JSBadge"></div>}
                </IconButton>}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo } = state.authUser;
    const { hasJobsSuggestion, hasMatchesCan, hasApplicants, hasMatchesRec } = userInfo
    const isFetching = state.histogramJobs.isFetching

    return {
        isAuthed, userInfo, isFetching, hasJobsSuggestion, hasMatchesCan, hasApplicants, hasMatchesRec
    }
}

export default connect(mapStateToProps)(ActivityNav)